import { SVGProps } from 'react'

export const SearchPersonOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...props}>
    <path
      fill="currentColor"
      d="M10.25 11c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM4.25 17c.22-.72 3.31-2 6-2 0-.7.13-1.37.35-1.99-2.73-.1-8.35 1.26-8.35 3.99v2h9.54c-.52-.58-.93-1.25-1.19-2H4.25zM19.68 17.02c.36-.59.57-1.28.57-2.02 0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4c.74 0 1.43-.22 2.02-.57L20.84 21l1.41-1.41c-1.5-1.5-.79-.8-2.57-2.57zM16.25 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    ></path>
  </svg>
)
